export default "/confetti.gif";